import React from "react";
import { isUndefined } from "utils/lodashExtracts";
import Image from "components/common/utils/Image";
import Cta from "components/common/Cta";
import MyCarousel, { airtableScientistRenderer } from "components/common/MyCarousel";
import "./styles.sass";
import Container from "react-bootstrap/Container";
import T from "types/index";
import { AirtableImages } from "components/common/utils/AirtableImage";

type Props = {
  scientists_title: string
  scientists: T.Charles.ScientistRecord[]
  start_slug: string
  cta_label: string
};

const ScientistSection = (props: Props) => (
  <div className="landing-scientist-section overflow-hidden">
    <div
      id="scientist-anchor"
      className="pathology-scientist-anchor pathology-anchor"
    />
    <h2 className="landing-scientist-section-h2">
      {props.scientists_title}
    </h2>
    {props.scientists.length > 1 ? (
      <>
        <div className="landing-scientist-section-subtitle">
          Une équipe pluridisciplinaire composée de médecins experts de leurs
          domaines
        </div>
        <Container className="my-carousel-container">
          <MyCarousel<T.Charles.ScientistRecord>
            data={props.scientists}
            prefix="scientist"
            renderItem={airtableScientistRenderer}
          />
        </Container>
      </>
    ) : (
      props.scientists.map(
        (scientist: T.Charles.ScientistRecord, i: number) => (
          <div key={i} className="one-doctor-chunk">
            <div className="one-doctor-card">
              <AirtableImages
                images={scientist.data.image_regular}
                className="one-doctor-image"
              />
              <div className="one-doctor-text-div">
                <h3 className="h4 text-left">{scientist.data.full_name}</h3>
                <div className="mb-4 mb-lg-0">{scientist.data.description}</div>
                <div className="landing-scientist-cta mt-auto">
                  <Cta
                    path={props.start_slug}
                    text={props.cta_label}
                    className="new-primary-cta"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      )
    )}
    <div className="landing-scientist-section-cta-wrapper">
      {props.scientists.length > 1 && (
        <Cta
          path={props.start_slug}
          text={props.cta_label}
          className="new-primary-cta landing-scientist-cta"
        />
      )}
    </div>
  </div>
);

export default ScientistSection;
